export class Phone {
    XID: string;
    Active: number;
    PhoneID: number;
    PhoneType: number;
    PhoneNum: string;   
    DisplayValue: string; 
}
